import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { typeIds } from "constants/typeId";
import { getByTypeIdAndNumberId } from "services/assistant.service";
import { useReservation } from "context/reservationContext";
import { useApp } from "context/appContext";

import FormAssistant from "./layout";

function FormAssistantContainer() {
  const {
    ccs,
    assistants,
    currentAssistant,
  } = useReservation();
  const { showNotification} = useApp();
  const { handleSubmit, errors, control, setValue, register } = useForm();

  const [typeId, setTypeId] = useState(typeIds[0].value);
  const [loading, setLoading] = useState(false);
  const [showNewFields, setShowNewFields] = useState(false);

  const onBlurTypeId = (value) => {
    if (value) {
      setTypeId(value);
    }
  };

  const onBlurNumberId = async (e) => {
    if (e) {
      const numberId = e.target.value;
      if (numberId) {
        console.log(assistants);
        const assistant = assistants.find(
          (ass) => ass.numberId === numberId && ass.typeId === typeId
        );
        if (assistant) {
          setValue("numberId", "");
          showNotification("No se puede agregar dos usuarios con el mismo documento de identidad.", "error");
        } else {
          const cc = ccs.find((c) => c === numberId);
          if (cc && typeId) {
            setValue("typeId", typeId);
            try {
              setLoading(true);
              const assistant = await getByTypeIdAndNumberId(typeId, cc);
              console.log(assistant);
              setValue("email", assistant.email);
              setValue("name", assistant.name);
              setValue("lastName", assistant.lastName);
              setValue("birthday", assistant.birthday);
              setValue("cellphone", assistant.cellphone);
              setValue("typeId", assistant.typeId || "CC");
              setValue("first", "no");
            } catch (err) {
              console.log(err);
            }
            setLoading(false);
          }
        }
      }
    }
  };

  const handleBlurNewUser = (value) => {
    setShowNewFields(value === "si");
  };

  return (
    <FormAssistant
      loading={loading}
      onBlurNumberId={onBlurNumberId}
      onBlurTypeId={onBlurTypeId}
      currentAssistant={currentAssistant}
      handleSubmit={handleSubmit}
      errors={errors}
      control={control}
      register={register}
      onBlurNewFields={handleBlurNewUser}
      showNewFields={showNewFields}
    />
  );
}

export default FormAssistantContainer;
